<template>
    <div id="LoginSocialMedia">
        
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name:'LoginSocialMedia',
    data(){
        return{
            userToken: null,
            ROOT_API: null
        }
    },
    methods: {
        getParams,
        login,
        startSession,
        createSite,
        goDashboard,
        goWizard
    },
    created(){
        this.ROOT_API = process.env.ROOT_API
    },
    mounted(){
        this.getParams()
    }

}
function getParams(){
    this.userToken = this.$router.currentRoute.query.token
    this.login()
}
function login(){
    let formData = new FormData()
    formData.append('code', this.userToken);
    axios ({
        method: 'post',
        url: this.ROOT_API+'/api/authorize',
        data:  formData,
        config: { headers: {'Content-Type': 'multipart/form-data' }}
    })
    .then(response => {
        console.log(response)
        if(response.data.status == 1){
            this.$session.start()
            this.startSession(response)
        } else{
            this.$router.push('/login')
        }
    })
}
function startSession(response){
    this.$session.set('jwt', response.data.token)
    this.$session.set('userEmail', response.data.email)
    if(response.data.sites.length > 0){
        if(response.data.sites[0].wizard == 1){
            this.$session.set('wizard', 1)
            this.goDashboard(localStorage.siteId)
        }else{
            this.$session.set('wizard', 0)
            this.goWizard(localStorage.siteId)
        }
    }else{
        this.createSite()
    }
}
function createSite(){
    let totalData = ''
    let token = this.$session.get('jwt')
    axios ({
        method: 'get',
        url: this.ROOT_API+'/api/site/create',
        data:  totalData,
        headers: {
            'Authorization': 'Bearer '+token,
            'Content-Type': 'application/x-www-form-urlencoded' 
        }
    })
    .then(response => {
        this.goWizard(response.data.siteId)
    })
    .catch(function (response) {
        console.log('Erro ao gerar ID do site')
    })
}
function goDashboard(site){
    this.$session.set('siteId', site)
    this.$router.push('/dashboard')
}
function goWizard(site){
    this.$session.set('siteId', site)
    this.$router.push('/wizard')
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/LoginSocialMedia.vue